import {
  GET_NOTIFICATIONS_REQUEST,
  GET_NOTIFICATIONS_SUCCESS,
  GET_NOTIFICATIONS_FAILURE,
  GET_NOTIFICATIONS_LATEST_REQUEST,
  GET_NOTIFICATIONS_LATEST_SUCCESS,
  GET_NOTIFICATIONS_LATEST_FAILURE,
  POST_NOTIFICATIONS_MARK_REQUEST,
  POST_NOTIFICATIONS_MARK_SUCCESS,
  POST_NOTIFICATIONS_MARK_FAILURE,
  TOGGLE_SYSTEM_NOTIFICATION_DIALOG,
  TOGGLE_RECOMMEND_RELOCATION_PERSONNEL_NOTIFICATION_DIALOG,
} from "../../constants/ActionTypes";
import { NotificationInfosApi } from "../api/NotificationInfosApi";
import { NOTIFICATIONS_PER_PAGE } from "../../constants/Constants";

/*** GET /notifications ***/
const getNotificationsRequest = () => ({
  type: GET_NOTIFICATIONS_REQUEST,
});

const getNotificationsSuccess = (notifications, pageInfo) => ({
  type: GET_NOTIFICATIONS_SUCCESS,
  payload: {
    notifications: notifications,
    pageInfo: pageInfo,
  },
});

const getNotificationsFailure = (error) => ({
  type: GET_NOTIFICATIONS_FAILURE,
  payload: {
    error: error,
  },
});

export function getNotifications(data) {
  return async (dispatch) => {
    dispatch(getNotificationsRequest());

    NotificationInfosApi.getNotifications(data, dispatch)
      .then((response) => {
        dispatch(
          getNotificationsSuccess(response.data.data, response.data.meta)
        );
      })
      .catch((error) => {
        dispatch(getNotificationsFailure(error.response));
      });
  };
}

/*** GET /notifications ***/
const getNotificationsLatestRequest = () => ({
  type: GET_NOTIFICATIONS_LATEST_REQUEST,
});

const getNotificationsLatestSuccess = (notifications) => ({
  type: GET_NOTIFICATIONS_LATEST_SUCCESS,
  payload: {
    notifications: notifications,
  },
});

const getNotificationsLatestFailure = (error) => ({
  type: GET_NOTIFICATIONS_LATEST_FAILURE,
  payload: {
    error: error,
  },
});

export function getNotificationsLatest() {
  return async (dispatch) => {
    dispatch(getNotificationsLatestRequest());

    NotificationInfosApi.getNotifications(
      {
        paging: 1,
        per_page: NOTIFICATIONS_PER_PAGE,
        page: 1,
      },
      dispatch
    )
      .then((response) => {
        dispatch(getNotificationsLatestSuccess(response.data.data));
      })
      .catch((error) => {
        dispatch(getNotificationsLatestFailure(error.response));
      });
  };
}

/*** POST /notifications/{id}/mark ***/
const postNotificationsMarkRequest = (id) => ({
  type: POST_NOTIFICATIONS_MARK_REQUEST,
  payload: {
    id: id,
  },
});

const postNotificationsMarkSuccess = (notification) => ({
  type: POST_NOTIFICATIONS_MARK_SUCCESS,
  payload: {
    notification: notification,
  },
});

const postNotificationsMarkFailure = (error) => ({
  type: POST_NOTIFICATIONS_MARK_FAILURE,
  payload: {
    error: error,
  },
});

export function postNotificationsMark(id, data) {
  return async (dispatch) => {
    dispatch(postNotificationsMarkRequest(id));

    NotificationInfosApi.postNotificationsMark(id, data, dispatch)
      .then((response) => {
        dispatch(postNotificationsMarkSuccess(response.data.data));
      })
      .catch((error) => {
        dispatch(postNotificationsMarkFailure(error.response));
      });
  };
}

export const toggleSystemNotificationDialog = (item = null) => ({
  type: TOGGLE_SYSTEM_NOTIFICATION_DIALOG,
  payload: {
    item: item,
  },
});

export const toggleRecommendRelocationPersonnelNotificationDialog = (item = null) => ({
  type: TOGGLE_RECOMMEND_RELOCATION_PERSONNEL_NOTIFICATION_DIALOG,
  payload: {
    item: item,
  },
});



// WEBPACK FOOTER //
// ./src/redux/actions/Notification.js